const Colours = {
  Amber:           '#FF9100',
  Black:           '#000',
  Blue:            '#00F',
  Blue1:           '#007bff',
  Blue2:           '#0d3c61',
  Brown:           '#754C24',
  DarkTint:        '#333333aa',
  Disabled:        '#888888',
  DefaultBkgrd:    '#fafafa',
  Gray:            '#555555',
  Gray1:           '#7C7C7C',
  Gray2:           '#A9A9A9',
  Gray3:           '#e9ecef',
  Gray4:           '#DBDBDB',
  Gray5:           '#C4C4C4',
  Gray6:           '#484848',
  Gray7:           '#808080',
  Gray8:           '#616061',
  Gray9:           '#A3A3A3',
  Green:           '#00b300',
  Green1:          '#1bb300',
  LightGray:       '#f1f1f1',
  LightGray1:      '#F8F8F8',
  LightGray2:      '#D9D9D9',
  LightGray3:      '#E6E8E8',
  LightGray4:      '#ACAAAA',
  LightGray5:      '#E0E0E0',
  LightGray6:      '#EEEEEE',
  DarkGray:        '#646363',
  DarkGray1:       '#474646',
  LightPrimary:    '#F9E7E7',
  LightBlue:       '#3DADFF',
  LightBlue2:      '#BBC5D7',
  LightBlue3:      '#e8f4fd',
  Orange:          '#ffa200',
  OrangePoiMarker: '#f15a24',
  Primary:         '#000000',
  Purple:          '#652483',
  DarkPurple:      '#552181',
  Teal:            '#0071A2',
  Red:             '#F00',
  Secondary:       '#DE006F',
  White:           '#fff',
  Transparent:     '#00000000',
  Yellow:          '#B8860B',
};

export default Colours;
